// Label and tone for a connection's update-mode (Plaid Link) button.
// Generic for every bank: driven only by the connection's status.
// - login_required / pending_expiration: the bank needs a new sign-in.
// - error: the last sync failed; update mode may repair it.
// - anything else (active): the connection works. The button stays (update
//   mode also adds or changes shared accounts) but reads neutrally.
export const NEEDS_SIGN_IN = ['login_required', 'pending_expiration'];

export function connectionButton(item) {
  const status = item && item.status;
  if (NEEDS_SIGN_IN.includes(status)) {
    return { label: 'Fix connection (sign in again)', needsAttention: true,
      title: 'The bank needs you to sign in again. Keeps the same connection.' };
  }
  if (status === 'error') {
    return { label: 'Fix connection', needsAttention: true,
      title: 'The last sync failed. Sign in to the bank again or update this connection. Keeps the same connection.' };
  }
  return { label: 'Update connection', needsAttention: false,
    title: 'Change which accounts are shared or update this connection. It is working; nothing needs fixing. Keeps the same connection.' };
}
